import { render, staticRenderFns } from "./registrantBlock.vue?vue&type=template&id=59d42252&scoped=true&"
import script from "./registrantBlock.vue?vue&type=script&lang=js&"
export * from "./registrantBlock.vue?vue&type=script&lang=js&"
import style0 from "./registrantBlock.vue?vue&type=style&index=0&id=59d42252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d42252",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSelect,VSpacer,VSwitch,VTextField,VTooltip})
